// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input, OnChanges } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { FeatureToggle } from '@coa/app/shared/feature-toggle/models/feature.toggle';
import { Observable } from 'rxjs';
import { FeatureToggleService } from '@coa/app/shared/feature-toggle/services/feature-toggle.service';

@Component({
  selector: 'coa-brand-summary',
  templateUrl: './brand-summary.component.html',
  styleUrls: ['./brand-summary.component.scss'],
})
export class BrandSummaryComponent implements OnChanges {
  @Input() clientId: string;
  @Input() brandName: string;
  @Input() storeNumber: number;
  @Input() percentageValue: number;
  @Input() paymentValue: number;
  @Input() borderColor: string;

  storeNumberKey = marker('{{ storeNumber }} stores included');
  percentageTooltip = marker('Change in foot traffic represents a percentage change in total visits between currently selected period and the corresponding previous period of the same time length.');
  paymentTooltip = marker('The payment conversion rate is the proportion of visitors in the store that made a purchase.');

  paymentsEnabled$: Observable<boolean>;

  constructor(
    private featureToggleService: FeatureToggleService,
  ) {
  }

  ngOnChanges(): void {
    if (this.clientId) {
      this.paymentsEnabled$ = this.featureToggleService.isFeatureAdded(FeatureToggle.PAYMENT_EVENTS_ENABLED, this.clientId);
    }
  }
}
